import { Flex, Space, Text, Textarea } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { TERMS_AND_CONDITIONS_CHARACTER_LIMIT } from '@features/invoicingSettings/constants/termsAndConditionsCharacterLimit'
import { useTrackInvoicingSettings } from '@features/invoicingSettings/hooks/useTrackInvoicingSettings'

import { useFormContext } from '../../../../../../../../../../../../hooks'
import { useDebouncedCallback } from '../../../../../../../../../../../../hooks/useDebouncedCallback'
import { InvoiceSettingsFormSchema } from '../../../../../../types/invoiceSettingsFormSchema'

export const DefaultTermsAndConditions = (): ReactElement => {
  const { t } = useTranslation()
  const { trackInvoicingSettings } = useTrackInvoicingSettings()
  const { FormItem, watch } = useFormContext<InvoiceSettingsFormSchema>()

  const termsAndConditions = watch('termsAndConditions')

  const handleDebouncedTermsAndConditionsTextareaChange = useDebouncedCallback(() =>
    trackInvoicingSettings('Terms and conditions Typed'),
  )

  return (
    <FormItem
      name="termsAndConditions"
      label={
        <Flex justifyContent="space-between">
          <Text colorVariant="secondary">
            {t('settings.organization.external_invoice.content.default_terms_and_conditions.label')}
          </Text>
          <Space size="s24" horizontal />
          <Text colorVariant="secondary">{`${termsAndConditions.length}/${TERMS_AND_CONDITIONS_CHARACTER_LIMIT}`}</Text>
        </Flex>
      }
      render={({ field: { onChange, ...rest } }) => {
        return (
          <Textarea
            {...rest}
            expandOnType
            maxHeight={160}
            maxLength={TERMS_AND_CONDITIONS_CHARACTER_LIMIT}
            onChange={(event) => {
              onChange(event)
              handleDebouncedTermsAndConditionsTextareaChange()
            }}
            placeholder={t('settings.organization.external_invoice.content.default_terms_and_conditions.placeholder')}
            resizable={false}
            rows={1}
          />
        )
      }}
    />
  )
}
